import { render, staticRenderFns } from "./document-jobs.vue?vue&type=template&id=2415fd48&"
import script from "./document-jobs.vue?vue&type=script&lang=js&"
export * from "./document-jobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports